import {locationPinSvg as Icon__small__locationPinSvg} from '../Icon__small/Icon__small--locationPin.js';

export var locationPin = {
  name: 'locationPin',
  category: 'icon',
  colorable: true,
  svg: Icon__small__locationPinSvg,
};
